<ion-content>
  <funz-menu class="funz-menu-page"></funz-menu>
</ion-content>
<ion-footer *ngIf="cordova">
  <ion-toolbar class="ion-no-padding">
    <mobile-footer-menu></mobile-footer-menu>
  </ion-toolbar>
</ion-footer>